module.exports = __webpack_public_path__ + "static/media/video-placeholder.1c9c6085.svg";